// Module
var code = "<a class=\"text-sm sps-btn sps-btn-outline btn-color-add add-btn\" id=\"addButton\" data-testid=\"search.add\"> <i class=\"fa fa-plus-circle\"></i><span data-bind=\"text: _labels.ADD\"></span> </a>";
// Exports
export default code;